<!--
 * @Description: 流程审批代理详情
 * @Autor: lwq
 * @Date: 2020-07-29 09:32:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-23 11:26:52
 * @FilePath: \mrc-base-server-view\src\views\approver\detailApprover.vue
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='disabled'
                       :showEdit="hasBtn('edit-on-behalf-approval-configuration-entry')"
                       :show_del="hasBtn('delete-on-behalf-approval-configuration-entry')"
                       :showReturn='false'
                       @handleReturn='handleReturn'
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <approverInfo :disabled='disabled'
                  @changeReadonly='handleEdit' />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import approverInfo from './modules/approverInfo'
import { updateApprover, delApprover } from '@/service/api/approver'
export default {
  components: { approverInfo },
  props: {},
  data () {
    return {
      disabled: false,
    };
  },
  validations: {},
  computed: {},
  created () { },
  watch: {},
  async mounted () {
    this.disabled = this.$store.state.iconstatus
  },
  methods: {
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
      this.$store.commit('set_iconstatus', this.disabled)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        delApprover({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'approver',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
